<!--~
  ~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
  ~ to an End-User License Agreement included in a separate file named EULA.txt
  ~ that is distributed with this file.
  -->
<button mat-icon-button class="md-icon-button"
        aria-label="Upload"
        (click)="showUploadDialog()">
    <mat-icon svgIcon="upload" aria-label="Upload"></mat-icon>
</button>
